import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const createCheckout = ({ country }) => (
	`mutation ($input: CheckoutCreateInput!) @inContext(country: ${country}) {
		checkoutCreate(input: $input) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default createCheckout;
